// src/components/TopBanner.jsx

import React, { useEffect, useRef, useState } from "react";
import LogoutButton from "./LogoutButton";
import "./TopBanner.css";

export default function TopBanner() {
  const [showUserMenu, setShowUserMenu] = useState(false);

  const menuRef = useRef(null);

  /* ============================================================
     LOGGED-IN USER
  ============================================================ */

  const userName =
    localStorage.getItem("userName") ||
    localStorage.getItem("username") ||
    "User";

  const userRole =
    localStorage.getItem("userRole") ||
    "Staff";

  /* ============================================================
     USER INITIAL
  ============================================================ */

  const getInitial = () => {
    if (!userName) return "U";

    return userName
      .trim()
      .charAt(0)
      .toUpperCase();
  };

  /* ============================================================
     CLOSE MENU WHEN CLICKING OUTSIDE
  ============================================================ */

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setShowUserMenu(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleOutsideClick
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleOutsideClick
      );
    };
  }, []);

  return (
    <header className="medical-top-banner">

      {/* ======================================================
          LEFT — HOSPITAL BRAND
      ====================================================== */}

      <div className="medical-banner-brand">

        <div className="medical-banner-logo">
          <i className="fa fa-heartbeat"></i>
        </div>

        <div className="medical-banner-title-area">

          <h1>
            Kolath Medical Centre
          </h1>

          <span>
            Medical Management System
          </span>

        </div>

      </div>


      {/* ======================================================
          RIGHT — LOGGED-IN USER
      ====================================================== */}

      <div
        className="medical-user-area"
        ref={menuRef}
      >

        <button
          type="button"
          className={`medical-user-button ${
            showUserMenu ? "active" : ""
          }`}
          onClick={() =>
            setShowUserMenu((prev) => !prev)
          }
          aria-expanded={showUserMenu}
        >

          {/* AVATAR */}

          <div className="medical-user-avatar">
            {getInitial()}
          </div>


          {/* NAME / ROLE */}

          <div className="medical-user-details">

            <span className="medical-user-name">
              {userName}
            </span>

            <span className="medical-user-role">
              {userRole}
            </span>

          </div>


          {/* ARROW */}

          <div className="medical-user-arrow">

            <i
              className={`fa ${
                showUserMenu
                  ? "fa-angle-up"
                  : "fa-angle-down"
              }`}
            ></i>

          </div>

        </button>


        {/* ====================================================
            USER DROPDOWN
        ==================================================== */}

        {showUserMenu && (

          <div className="medical-user-dropdown">

            {/* USER INFO */}

            <div className="medical-dropdown-profile">

              <div className="medical-dropdown-avatar">
                {getInitial()}
              </div>

              <div>

                <strong>
                  {userName}
                </strong>

                <span>
                  {userRole}
                </span>

              </div>

            </div>


            <div className="medical-dropdown-divider"></div>


            {/* LOGOUT */}

            <LogoutButton
              className="medical-dropdown-logout"
            />

          </div>

        )}

      </div>

    </header>
  );
}